export const setUrlParams = (params: { [key: string]: string }) => {
  if (window.history.replaceState) {
    const searchParams = new URLSearchParams(window.location.search);
    Object.keys(params).forEach((key: string) => {
      searchParams.set(key, params[key]);
    });
    if (searchParams.size === 0) {
      return;
    }
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({ path: newurl }, '', newurl);
  }
};

export const setUrlParam = (key: string, value: string) => {
  setUrlParams({ [key]: value });
};

export const getUrlParam = (key: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key);
};

export const getUrlParamList = (key: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.getAll(key);
};

export const removeUrlParam = (keys: string[]) => {
  if (window.history.replaceState) {
    const searchParams = new URLSearchParams(window.location.search);
    keys.forEach(key => searchParams.delete(key));
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`;
    window.history.replaceState({ path: newurl }, '', newurl);
  }
};

export const isValidURL = (str: string) => {
  if (!str) {
    return false;
  }

  const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(:[0-9]+)?(\/[^?#]*)?(\?[^#]*)?(#.*)?$/;

  return urlRegex.test(str);
};
